'use strict';

exports.__esModule = true;
exports['default'] = createAll;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createProvider = require('./createProvider');

var _createProvider2 = _interopRequireDefault(_createProvider);

var _createConnector = require('./createConnector');

var _createConnector2 = _interopRequireDefault(_createConnector);

var _createConnectDecorator = require('./createConnectDecorator');

var _createConnectDecorator2 = _interopRequireDefault(_createConnectDecorator);

function createAll(React) {
  var Provider = _createProvider2['default'](React);
  var connect = _createConnectDecorator2['default'](React, _createConnector2['default'](React));

  // provider and Connector are deprecated and removed from public API
  return { Provider: Provider, connect: connect };
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/lib/components/createAll.js
 ** module id = 98
 ** module chunks = 0
 **/